import { DatePicker, Form, type FormItemProps } from 'antd';

import type { Ii18nLabel } from '@/types/common';

import { getFormItemLabel } from './utils';

const { RangePicker } = DatePicker;

interface DatePickerProps extends FormItemProps, Ii18nLabel {
  showTime?: boolean;
  disabled?: boolean;
}

export const DateRangePicker = ({ name, label, i18nLabel, rules, showTime = false, disabled }: DatePickerProps) => {
  const fieldLabel = getFormItemLabel(i18nLabel, label);

  return (
    <Form.Item name={name} label={fieldLabel} rules={rules}>
      <RangePicker disabled={disabled} showTime={showTime} />
    </Form.Item>
  );
};
